import React from 'react';

import moment from 'moment';

import { Storage } from 'services/Storage';

import { callApi } from 'util/CallAPI';
import { IntlMessage } from 'util/IntlMessages';
import { classNames, isArray, isEmpty } from 'util/utils';

import { GET_NOTIFICATIONS, MARK_AS_READ, ADMIN_UPDATE_USER } from 'constants/apiConstant';

const NotificationItem = (props) => {
  return (
    <div onClick={props.onClick} className={classNames([`notificationDropdownDetail`, props.read && 'readMessage'])}>
      <div className={'norificationDropdownItem'}>
        <h2>{props.title}</h2>
        {props.pcv && <div className="d-flex flex-wrap basicDetail"></div>}
        <span>{props.time}</span>
      </div>
    </div>
  );
};

const NotificationDropdown = (props) => {
  const { updatedCount } = props;

  const [notifyData, setNotifyData] = React.useState([]);

  const getNotifications = React.useCallback(async () => {
    const [err, res] = await callApi({ ...GET_NOTIFICATIONS, request: { page: 1, limit: 10 } });
    if (!err && res?.code === 'OK' && isArray(res?.data?.list)) {
      if (res?.data?.isPermissionChanged && isArray(res.data.userPermissions)) {
        callApi({ ...ADMIN_UPDATE_USER, request: { isPermissionChanged: false } });
        const setPermit = Object.fromEntries(res.data.userPermissions.data.map((x) => [x.module, x.permissions]));
        Storage.set('userPermissions', setPermit);
      }

      setNotifyData([...res.data.list]);
      void updatedCount?.();

      return;
    }
    setNotifyData([]);
  }, [updatedCount]);

  const markAsRead = React.useCallback(
    async (id) => {
      const [, res] = await callApi({ ...MARK_AS_READ, request: { id: id } });
      if (res && res.code === 'OK') getNotifications();
    },
    [getNotifications],
  );

  React.useEffect(() => {
    getNotifications();
  }, [getNotifications, props.count]);

  return (
    <div className="notificationDropdown">
      <div className="notificationItem">
        <div className="notificationTitle">
          <IntlMessage id="app.New" />
        </div>
        <div className="notificationInner">
          {isArray(notifyData) && !isEmpty(notifyData)
            ? notifyData.map((e, i) => {
                const time = moment(e.updatedAt).fromNow();
                return (
                  <NotificationItem
                    key={i}
                    onClick={() => markAsRead(e.id)}
                    title={e.title}
                    pcv={e.message}
                    time={time}
                    read={e.isRead}
                  />
                );
              })
            : 'No Notification Found'}
          <a href="/notifications" className="viewLink">
            View All Notifications
          </a>
        </div>
      </div>
    </div>
  );
};
export default NotificationDropdown;
